export const INDEX_PAGE = '/index'
export const FSF_PAGE = '/flight-search'
export const COMPONENT_TEST_PAGE = '/bt-test-component-page'

export const STATIC_PAGES = [INDEX_PAGE, FSF_PAGE]
export const VOUCHER_POST_REQUEST_PAGES = [FSF_PAGE, COMPONENT_TEST_PAGE]
